module.exports = __webpack_public_path__ + "assets/img/logo.61a7d074.svg";